import { render } from "./directions-car.svg?vue&type=template&id=ccca154a?inline"
const script = {}
script.render = render

export default script